import React from 'react';
import './Badge.scss';

export default function Badge({
  badgeType = 'default',
  badgeText = 'Badge Text',
  labelType = 'default',
  dot = false,
  config = {},
  className,
  children,
}) {
  let classNames = [];
  if (badgeType === 'pill') {
    classNames = ['badge-pill'];
  }

  const rawText = String(children);
  let displayText = rawText;
  if (labelType === 'TitleCase') {
    const toTitleCase = str =>
      str
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    displayText = toTitleCase(rawText);
  }

  return (
    <span
      className={` badge ${classNames.join(' ')} ${className} `}
      style={{
        backgroundColor: config?.backgroundColor || '#f0f0f0',
        color: config?.fontColor || '#000',
        borderColor: config?.borderColor || '#ccc',
      }}
    >
      <div className="d-flex align-items-center gap-1">
        {dot && (
          <span
            className="badge-dot"
            style={{
              backgroundColor: config?.dotColor || 'black',
              width: config?.dotSize,
              height: config?.dotSize,
            }}
          />
        )}
        <span
          style={{
            fontSize: config?.fontSize,
            fontWeight: config?.fontWeight,
            lineHeight: config?.lineHeight,
          }}
        >
          {displayText || badgeText}
        </span>
      </div>
    </span>
  );
}
